import { createEvent } from '../utils/create-event';
import store from 'store';
import {ROOT_ELEMENT} from '../constants';

const STORAGE_KEY = 'hasSeenPreloader';
const STORAGE_VALUE = 'true';
const preLoader = $('.preloader');

window.addEventListener('load', () => {
    store.set(STORAGE_KEY, STORAGE_VALUE);
});

document.addEventListener('DOMContentLoaded', function () {

    setTimeout(() => {
        if (store.get(STORAGE_KEY) === STORAGE_VALUE) {

            $('html, body').animate({
                scrollTop: 0
            }, 0);

            preLoader.addClass('hide');

            setTimeout(() => {

                preLoader.remove();

                ROOT_ELEMENT.dispatchEvent(createEvent('preloaderEnd')); // used in cookies message

            }, 500);
        }
    }, 2000);

});



// WEBPACK FOOTER //
// ./scripts/elements/preloader.js